import type { ResponseNode } from '../../../types/wizardTypes';

function getType(value: unknown): ResponseNode['type'] {
  if (value === null || value === undefined) return 'null';
  if (Array.isArray(value)) return 'array';
  const t = typeof value;
  if (t === 'string') return 'string';
  if (t === 'number') return 'number';
  if (t === 'boolean') return 'boolean';
  if (t === 'object') return 'object';
  return 'string';
}

function truncate(value: string, max = 80): string {
  return value.length > max ? value.slice(0, max) + '...' : value;
}

function buildNodes(obj: unknown, parentPath: string): ResponseNode[] {
  if (obj === null || obj === undefined || typeof obj !== 'object') return [];

  if (Array.isArray(obj)) {
    if (obj.length === 0) return [];
    const first = obj[0];
    const firstType = getType(first);
    if (firstType === 'object' || firstType === 'array') {
      return buildNodes(first, parentPath + '[]');
    }
    return [];
  }

  return Object.entries(obj as Record<string, unknown>).map(([key, value]) => {
    const path = parentPath ? `${parentPath}.${key}` : key;
    const type = getType(value);

    if (type === 'object') {
      return {
        key,
        path,
        type,
        children: buildNodes(value, path),
      };
    }

    if (type === 'array') {
      const arr = value as unknown[];
      const children = arr.length > 0 ? buildNodes(arr, path) : [];
      return {
        key,
        path,
        type,
        children,
      };
    }

    return {
      key,
      path,
      type,
      example: truncate(String(value)),
    };
  });
}

export function parseResponseToTree(json: unknown): ResponseNode[] {
  if (json === null || json === undefined) return [];
  if (typeof json !== 'object') return [];
  return buildNodes(json, '');
}
